const ns = '[WorkData in redux] ';

export const SYNC_WORK_DATA = `${ns}sync with workData`;
